// @flow
import remote from './remote';

export function getFriends(query: Object = {}) {
  return remote.get('friends', query);
}

export function searchUsers(query: Object) {
  return remote.get('search/users', query);
}

export function removeFriend(userId: number) {
  return remote.post(`users/${userId}/unfriend`);
}

export function addFriendToGroups(friendId: number, groupIds: Array<number>) {
  return remote.post(`friends/${friendId}/groups`, { groups: groupIds });
}

export function removeFriendFromGroups(friendId: number, groupIds: Array<number>) {
  return remote.delete(`friends/${friendId}/groups`, { groups: groupIds });
}

